module.exports = __webpack_public_path__ + "static/media/S3C2.fed1fbaf.svg";